import { AxiosInstance, AxiosRequestConfig } from 'axios'
import { handleActions, ReduxCompatibleReducer } from 'redux-actions'

import { IFilter } from '../types'
import { generateActions, IActionsMap } from './actions'
import { generateConstants, TConstantMap } from './constants'
import {
  DraftProps,
  generateActionHandlers,
  generateInitialState,
} from './reducer'
import { generateSaga } from './saga'
import {
  generateSelectors,
  generateStructuredSelector,
  ISelectorProps,
  ISelectorStructuredProps,
} from './selectors'

interface IReduxProps {
  id: string
  initialState?: any
  initialFilters?: {
    [key: string]: IFilter[]
  }
  url: string
  sagas: any[]
  customAxiosClient?: ({ ...options }: AxiosRequestConfig) => Promise<any>
}

export interface TConnectInfinityRedux
  extends IActionsMap,
    ISelectorStructuredProps {}

export type IReturnRedux = {
  id?: string
  constants?: TConstantMap
  actions?: IActionsMap
  reducer?: ReduxCompatibleReducer<DraftProps, DraftProps>
  selectors?: ISelectorProps
  structuredSelector?: ISelectorStructuredProps
  mappedReducers?: any
  runSagas?: (sagas: any) => void
}
export function generateRedux(props: IReduxProps): IReturnRedux {
  const {
    id,
    initialState = {},
    initialFilters = {},
    url,
    sagas = [],
    customAxiosClient,
  } = props

  const constants = generateConstants(id)

  const actions = generateActions(constants)

  // overwrite actionHandlers if required
  const actionHandlers = {
    // [constants.]
  }

  const generatedInitialState = generateInitialState({
    initFilter: initialFilters, // additional to defaults
    initialState, // additional to defaults,
  })

  const defaultActionHandlers = generateActionHandlers({
    constants,
    actionHandlerCallbacks: {
      // handleRequest: produce/fn? // called in addition to default handler
    },
  })

  const reducer = handleActions(
    {
      ...defaultActionHandlers,
      ...actionHandlers,
    },
    generatedInitialState,
  )

  const selectors = generateSelectors(id)

  const structuredSelector = generateStructuredSelector(selectors)

  const generatedSaga = generateSaga({
    constants,
    actions,
    selectors,
    url,
    customAxiosClient,
  })

  const runSagas = function (rootSaga): void {
    rootSaga.run(generatedSaga)
    sagas.map((saga) => rootSaga.run(saga({ constants, actions, selectors })))
  }

  return {
    id,
    constants,
    actions,
    reducer,
    selectors,
    structuredSelector,
    mappedReducers: {
      [id]: reducer,
    },
    runSagas,
  }
}
